<template>
    <div class="$attrs.class">
    <label class="upper">Credit Management</label>
    <hr class="mt-0"/>
    <label class="upper">Session Credits</label>
    <form-component>
        <form
            novalidate="novalidate"
            @submit.prevent="save"
        >
        <div class="form-row">
            <div class="col-lg-6 col-12 remaining-credits border"> Remaining Session Credits: {{school.credits.remainingSessionCredits}}</div>
        </div>
        <div class="form-row">
            <div class="col-lg-6 col-12">
                <input-text
                id="sessionCreditAmount"
                v-model="sessionCreditAmount"
                v-validate="isSessionRequired ? 'required': ''"
                name="sessionCreditAmount"
                data-vv-name="sessionCreditAmount"
                data-vv-as="Session Credit Amount"
                label="Session Credit Amount"
                type="number"
                :error="errors.first('sessionCreditAmount')"
            />
            </div>
            <div class="col-lg-6 col-12 button-inputs">
                    <b-form-radio-group
                        class="radio-button"
                        id="btn-radios-sessions"
                        v-model="sessionOptionSelected"
                        :options="options"
                        :aria-describedby="sessionCreditAmount"
                        name="btn-radios-sessions"
                        buttons>
                    </b-form-radio-group>
            </div>
        </div>
        <div v-if="sessionOptionSelected" class="form-row">
            <div class="col-12 offset-lg-6 col-lg-6">
                <b-button class="w-100" variant="primary" @click="clearSessionSelection()">Cancel Session Adjustment</b-button>
            </div>
        </div>
        <hr/>
        <label class="upper">Workshop Credits</label>
        <div class="form-row">
            <div class="col-lg-6 col-12 remaining-credits border"> Remaining Workshop Credits: {{school.credits.remainingWorkshopCredits}}</div>
        </div>
        <div class="form-row">
            <div class="col-lg-6 col-12">
                <input-text
                    id="workshopCreditAmount"
                    v-model="workshopCreditAmount"
                    v-validate="isWorkshopRequired ? 'required': ''"
                    name="workshopCreditAmount"
                    data-vv-name="workshopCreditAmount"
                    data-vv-as="Workshop Credit Amount"
                    label="Workshop Credit Amount"
                    type="number"
                :error="errors.first('workshopCreditAmount')"
            />
            </div>
            <div class="col-lg-6 col-12 button-inputs">
                    <b-form-radio-group
                        class="radio-button"
                        id="btn-radios-workshops"
                        v-model="workshopOptionSelected"
                        :options="options"
                        :aria-describedby="workshopCreditAmount"
                        name="btn-radios-workshops"
                        buttons>
                    </b-form-radio-group>
            </div>
        </div>
        <div v-if="workshopOptionSelected" class="form-row">
            <div class="col-12 offset-lg-6 col-lg-6">
                <b-button class="w-100" variant="primary" @click="clearWorkshopSelection()">Cancel Workshop Adjustment</b-button>
            </div>
        </div>
        <button type="submit" class="btn btn-primary btn-wide mt-4">
            <font-awesome-icon
                v-if="school.saving"
                :spin="true"
                :icon="['fas', 'spinner']"
                class="icon alt"/>
            <span v-else>Save Changes</span>
        </button>
        </form>
    </form-component>
    </div>
</template>

<script>
import FormComponent from '@/components/FormComponent.vue';
import InputText from '@/components/inputs/InputText.vue';

export default {
    name: 'CreditManagement',
    components: {
        FormComponent,
        InputText
    },
    inject:['school'],
    data() {
        return {
            sessionCreditAmount: '',
            workshopCreditAmount: '',
            sessionOptionSelected: '',
            workshopOptionSelected: '',
            options: [
                {text: 'Add', value: 'add'},
                {text: 'Remove', value: 'remove'}
            ]
        }
    },
    computed:{
        isSessionRequired(){
            return this.sessionOptionSelected.length && !this.sessionCreditAmount.length ? true : false;
        },
        isWorkshopRequired(){
            return this.workshopOptionSelected.length && !this.workshopCreditAmount.length ? true : false;
        }
    },
    methods: {
        clearSessionSelection() {
            this.sessionOptionSelected = '';
            this.sessionCreditAmount = '';
        },
        clearWorkshopSelection() {
            this.workshopOptionSelected = '';
            this.workshopCreditAmount = '';
        },
        async save() {
            const isValid = await this.$validator.validateAll()
            if (!isValid)
                return;

            this.errors.clear();
            try {
                if(!this.sessionOptionSelected.length && !this.workshopOptionSelected.length)
                    return;

                if(this.sessionCreditAmount.length) 
                    await this.school.updateSessionCreditsAndReset(this.sessionOptionSelected, this.sessionCreditAmount);

                if(this.workshopCreditAmount.length){
                    await this.school.updateWorkshopCreditsAndReset(this.workshopOptionSelected, this.workshopCreditAmount);
                }
            
                this.$store.commit('setGlobalAlert', {
                    msg: 'Credits Adjusted!',
                });
            } catch {
                this.$store.commit('setGlobalAlert', {
                    msg: 'Failed to save. Please try again!', error: true,
                });
            } finally {
                this.clearSessionSelection();
                this.clearWorkshopSelection();
            }
        },
    }
}
</script>

<style lang="scss" scoped>
label.upper {
    @include label;

    color: $green;
    margin-bottom: 20px;
}

.button-inputs{
    
    margin-top: 2rem;
    .radio-button{
        width: 100%;
    }
}
.remaining-credits {
    margin-bottom: 1rem;
    font-size: 17px;
    background-color: $off-blue;
    width: 100%;
    padding: 1rem;
    border-radius: 5px;
    text-align: center;
}
</style>